(function(StringUtils) {
    function replaceHTMLCharacters(text, replacement = '') {
        // Find HTML tags and replace them with an empty value
        return text.replace(/(<([^>]+)>)/ig, replacement);
    }
    StringUtils.replaceHTMLCharacters = replaceHTMLCharacters;
    function replaceStringAt(str, index, char) {
        const a = str.split('');
        a[index] = char;
        return a.join('');
    }
    StringUtils.replaceStringAt = replaceStringAt;
    function capitalizeFirstLetter(value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
    StringUtils.capitalizeFirstLetter = capitalizeFirstLetter;
    function getNonAlphanumericCharacterCount(text) {
        var _text_match;
        var _text_match_length;
        return (_text_match_length = (_text_match = text.match(/[^a-zA-Z0-9]/g)) === null || _text_match === void 0 ? void 0 : _text_match.length) !== null && _text_match_length !== void 0 ? _text_match_length : 0;
    }
    StringUtils.getNonAlphanumericCharacterCount = getNonAlphanumericCharacterCount;
    function removeUnrenderableCharacters(text) {
        const textWithoutHTMLTags = replaceHTMLCharacters(text);
        return textWithoutHTMLTags.replace(/['"&<>/()]/g, '');
    }
    StringUtils.removeUnrenderableCharacters = removeUnrenderableCharacters;
    function parseFormattedNumber(value) {
        return parseInt((value === null || value === void 0 ? void 0 : value.replace(/\D/g, '')) || '0', 10);
    }
    StringUtils.parseFormattedNumber = parseFormattedNumber;
})(StringUtils || (StringUtils = {}));
export var StringUtils;
